import { reactive } from 'vue';

export const criarObrasTpServico = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdobratpservico: 0,
        nmobratpservico: '',
        detalhamento: '',
        ativo: 'S',
        ckcidadao: 'N',
        idusuario: 0
    });
};